const loading = require("./12SegLoading.gif");
export default loading;
